import React from "react";
import PropTypes from "prop-types";

const RadioButtonGroup = ({
  name,
  id,
  label,
  selectedValue,
  handleChange,
  options,
  required,
  disabled,
}) => {
  return (
    <div>
      <label
        className="form-label col-form-label col-md-3 w-100 fs-5 inmate-label"
        // style={{ color: "#20252aa6", fontWeight: "400" }}
      >
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <div className="d-flex gap-3">
        {options?.map((option) => (
          <div key={option.value} className="form-check">
            <input
              type="radio"
              className="form-check-input"
              name={name}
              id={option.value}
              value={option.value}
              checked={selectedValue === option.value}
              onChange={handleChange}
              required={required}
              disabled={disabled}
            />
            <label className="form-check-label fs-5" htmlFor={option.value}>
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

RadioButtonGroup.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  selectedValue: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

RadioButtonGroup.defaultProps = {
  required: false,
  disabled: false,
  id: "",
};

export default RadioButtonGroup;
